import { render, staticRenderFns } from "./channeldetailout.vue?vue&type=template&id=d814e23a&scoped=true&"
import script from "./channeldetailout.vue?vue&type=script&lang=js&"
export * from "./channeldetailout.vue?vue&type=script&lang=js&"
import style0 from "./channeldetailout.vue?vue&type=style&index=0&id=d814e23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d814e23a",
  null
  
)

export default component.exports